import { Box, TColor, TSpacingStep, colors } from '@bridebook/ui';
import { FC } from 'react';

interface IProps {
  spacingTop?: TSpacingStep;
  spacingBottom?: TSpacingStep;
  color?: TColor;
}

const Divider: FC<IProps> = ({ spacingTop = 3, spacingBottom = 3, color = 'space15' }) => (
  <Box mt={spacingTop} mb={spacingBottom} h={1} style={{ backgroundColor: colors[color] }}></Box>
);

Divider.displayName = 'Divider';

export default Divider;
